import { useCallback } from "react";
import { parseAnnouncementMessage } from "./utils";
import { useAnnouncementStore } from "./useAnnouncementStore";
export const useGetPostHogAnnouncement = () => {
    const { payloads } = useAnnouncementStore();
    return useCallback((flag) => {
        const announcement = payloads?.[flag];
        if (announcement)
            return parseAnnouncementMessage(announcement);
    }, [payloads]);
};
export const usePostHogAnnouncement = (flag) => {
    const { isLoaded } = useAnnouncementStore();
    const getAnnouncement = useGetPostHogAnnouncement();
    return {
        isLoaded,
        announcement: getAnnouncement(flag),
    };
};
export const usePostHogAnnouncements = (flags) => {
    const { isLoaded } = useAnnouncementStore();
    const getAnnouncement = useGetPostHogAnnouncement();
    return {
        isLoaded,
        announcements: flags.map(getAnnouncement),
    };
};
